import { cn } from '../cn';
import Button from '../Input2/Button';
import { General } from '../StrokeIcons';

export type CampaignDayAddButtonPureProps = {
  onClick?: () => void;
  disabled?: boolean;
  disabledTooltip?: string;
  /**
   * When true, the host day card is rendering in the purple
   * "Not in template" tint. Swap the hover/border colours to purple so
   * this footer reads as part of the same tinted surface — otherwise
   * a generic blue hover here looks foreign against a purple card.
   */
  isDifferentFromTemplate?: boolean;
  className?: string;
};

export function CampaignDayAddButtonPure({
  onClick,
  disabled,
  disabledTooltip,
  isDifferentFromTemplate,
  className,
}: CampaignDayAddButtonPureProps) {
  return (
    <Button
      data-testid="campaign-day-add"
      text
      size="sm"
      textAlign="center"
      disabled={disabled}
      tooltip={disabled ? disabledTooltip : undefined}
      onClick={onClick}
      className={cn(
        'w-full justify-center rounded-none border-0 border-t border-dashed bg-transparent py-2',
        isDifferentFromTemplate
          ? 'border-purple-300 text-lynch-700 dark:border-purple-700 dark:text-lynch-300'
          : 'border-lynch-300 text-lynch-700 dark:border-slate-700 dark:text-lynch-300',
        isDifferentFromTemplate
          ? 'hover:border-solid hover:border-purple-500 hover:bg-purple-50 hover:text-purple-700 dark:hover:border-purple-400 dark:hover:bg-purple-950 dark:hover:text-purple-300'
          : 'hover:border-solid hover:border-blue-500 hover:bg-blue-50 hover:text-blue-700 dark:hover:border-blue-400 dark:hover:bg-blue-950 dark:hover:text-blue-300',
        // Keep the disabled hover neutral regardless of the card tint —
        // the Tailwind `disabled:hover:` selectors reset bg + text.
        isDifferentFromTemplate
          ? 'disabled:hover:border-dashed disabled:hover:border-purple-300 disabled:hover:bg-transparent disabled:hover:text-lynch-700'
          : 'disabled:hover:border-dashed disabled:hover:border-lynch-300 disabled:hover:bg-transparent disabled:hover:text-lynch-700',
        className,
      )}>
      <span className="inline-flex items-center gap-1">
        <General.Plus className="size-3.5" />
        add step
      </span>
    </Button>
  );
}
